import { useEffect, useState } from "react";
import { Table, Space } from "antd";
import { setting as settingService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { useRequest } from "ahooks";
import AdditionalPointAddButton from "./AdditionalPointAddButton";
import AdditionalPointEditButton from "./AdditionalPointEditButton";
import AdditionalPointDeleteButton from "./AdditionalPointDeleteButton";

import styles from "./index.module.less";

function AdditionalPoint() {
  const [version, setVersion] = useState(Date.now());
  const auth = useAuthContext();
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return settingService.listAdditionalPoint(params, token);
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          page: 1,
          page_size: 50,
        },
        auth.token
      );
    }
  }, [run, auth, version]);

  const columns = [
    {
      title: "序号",
      key: "num",
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "名称",
      dataIndex: "name",
    },
    {
      title: "分值",
      dataIndex: "value",
    },
    {
      title: "操作",
      key: "operate",
      width: 120,
      render: (record) => (
        <Space>
          <AdditionalPointEditButton
            additionalPointId={record.id}
            token={auth.token}
            callback={setVersion}
          />
          <AdditionalPointDeleteButton
            additionalPointId={record.id}
            token={auth.token}
            callback={setVersion}
          />
        </Space>
      ),
    },
  ];
  return (
    <div className={styles.additionalPoint}>
      <div className="table-toolbar">
        <div className="left">
          <AdditionalPointAddButton token={auth.token} callback={setVersion} />
        </div>
        <div className="right"></div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}

export default AdditionalPoint;
